import logo from "./logo.svg";
import "./App.scss";
import { HashRouter as Router, Routes, Route, Outlet, Navigate } from "react-router-dom";
import Home from "./pages/Home/Home";
import { useEffect, useState } from "react";
import Header from "./components/Header/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import Staff from "./pages/Staff/Staff";
import SignIn from "./pages/SignIn/SignIn";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import CompanyInfo from "./pages/CompanyInfo/CompanyInfo";
import { ProtectRoute } from "./utils/ProtectRoutes";
import { LoadingSpinner } from "./components/LoadingSpinner/LoadingSpinner";
import toast, { Toaster } from "react-hot-toast";
import { useStateValue } from "./StateProvider";
import TaskTemp from "./pages/TaskTemp/TaskTemp";
import ProjectTemp from "./pages/ProjectTemp/ProjectTemp";
import TaskTempList from "./pages/TaskTemp/component/TaskList/TaskTempList";
import AddUpdateTaskTemp from "./pages/TaskTemp/AddUpadteTaskTemp/AddUpadteTaskTemp";
import AddUpdateSubTask from "./pages/TaskTemp/component/AddUpdateSubTask/AddUpdateSubTask";
import AddUpdateProjectTemp from "./pages/ProjectTemp/component/AddUpdateProjectTemp/AddUpdateProjectTemp";
import ProjectTempList from "./pages/ProjectTemp/component/ProjectTempList/ProjectTempList";
import DisableBackButton from "./utils/DisableBackButton";
import useDisableScroll from "./utils/useDisableScroll ";
import TaskList from "./pages/Task/TaskList/TaskList";
import AddUpdateTask from "./pages/Task/AddUpdateTask/AddUpdateTask";
import AddUpdateSubtask from "./pages/Task/AddUpdateSubTask/AddUpdateSubTask";
import { checkSysConfig, getUserInfo } from "./apiCall";
import Setting from "./pages/Setting/Setting";
import Project from "./pages/Project/Project/Project";
import AddUpdateProject from "./pages/Project/AddUpdateProject/AddUpdateProject";
import Notification from "./pages/Notification/Notification/Notification";
import AddNotification from "./pages/Notification/AddNotification/AddNotification";
import Report from "./pages/Report/Report";
import ScrollToTop from "./utils/ScrollToTop";
import UserActivity from "./pages/UserActivity/UserActivity";

// import Task from "./pages/Task/Task";
// import AddUpdateTaskTemp from "./pages/TaskTemp/AddUpadteTaskTemp/AddUpadteTaskTemp";

function App() {
  const [{ userLoggedIn, sysConfig, isLoading }, dispatch] = useStateValue();
  const [isToggled, setIsToggle] = useState(false);
  useDisableScroll();
  // DisableBackButton()

  // ************************************ toggle fun start ************************************
  const toggle = () => {
    console.log("toggle ssssssssssssssssssssssssssss")
    setIsToggle(!isToggled);
  };
  // ************************************ toggle fun end ************************************

  // useEffect(() => {
  //   console.log(window.innerWidth >600)
  //   if (window.innerWidth > 600) {
  //     // setIsToggle(true)
  //     console.log("truefffffffffffffffffffffffffffffffffffffffffffffff",isToggled)
  //     setTimeout(()=>{
  //       console.log("truefffffffffffffffffffffffffffffffffffffffffffffff",isToggled)

  //     },1000)
  //     console.log("truefffffffffffffffffffffffffffffffffffffffffffffff")
  //   }
  //   else {
  //     console.log("falsewwwwwwwwwwwwwwwwwwwwwwwwwwww")
  //     setIsToggle(false);
  //   }
  // }, []);
  useEffect(() => {
    // Apply overflow hidden to body when loading starts
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Clean up the overflow style on unmount
    return () => {
      document.body.style.overflow = "";
    };
  }, [isLoading]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getUserInfo();
      console.log(response);
      if (response?.status === 200) {
        dispatch({ type: "SET_USER_INFO", data: response?.data });
      } else if (response?.response) {
        toast.error(response.response.data.status);
      }

      try {
        const re = await checkSysConfig();
        if (re?.status === 200) {
          console.log(re?.data);
          dispatch({ type: "SET_SYS_CONFIG", data: re?.data });
        } else {
          // toast.error(response.response.data.message);
        }
      } catch { }
    };
    if (userLoggedIn && Object.keys(sysConfig).length === 0) {
      fetchData();
    }
  }, [userLoggedIn]);

  return (
    <div
      id="main-wrapper"
      className={`${isToggled ? " main-wrapper toggled" : "main-wrapper"}`}
    >
      <Router>
        {isLoading && <LoadingSpinner />}
        <ScrollToTop />
        <Toaster />
        {/* <DisableBackButton /> */}
        <Routes>
          <Route
            path="/sign-in"
            element={
              <ProtectRoute>
                <SignIn />
              </ProtectRoute>
            }
          ></Route>
          <Route
            path="/change-password"
            element={
              <ProtectRoute>
                <ChangePassword />
              </ProtectRoute>
            }
          ></Route>
          <Route
            path="/"
            element={
              <ProtectRoute>
                <Header toggle={toggle} />
                <Sidebar toggle={toggle} isToggled={isToggled} />
                <Outlet />

                {/* <Home /> */}
              </ProtectRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="staff" element={<Staff />} />
            <Route path="setting" element={<Setting />} />
            <Route path="company-info" element={<CompanyInfo />} />
            <Route path="task-template" element={<TaskTempList />} />
            <Route path="add/task-template" element={<AddUpdateTaskTemp />} />
            <Route
              path="add/task-template/:projectId/:projectName"
              element={<AddUpdateTaskTemp />}
            />
            <Route
              path="update/task-template/:temId"
              element={<AddUpdateTaskTemp />}
            />
            <Route
              path="add/subtask/:temId/:tName"
              element={<AddUpdateSubTask />}
            />
            <Route
              path="project/:projectId/:pName/add/subtask/:temId/:tName"
              element={<AddUpdateSubTask />}
            />
            <Route
              path="update/subtask/:subtaskId"
              element={<AddUpdateSubTask />}
            />
            <Route path="project-template" element={<ProjectTempList />} />
            <Route
              path="add/project-template"
              element={<AddUpdateProjectTemp />}
            />
            <Route
              path="update/project-template/:projectId"
              element={<AddUpdateProjectTemp />}
            />
            <Route path="task" element={<TaskList />} />
            <Route path="add/task" element={<AddUpdateTask />} />
            <Route path="update/task/:taskId" element={<AddUpdateTask />} />
            <Route
              path="update/project/:projectId/task/:taskId"
              element={<AddUpdateTask />}
            />
            <Route path="add/subtask/:taskId" element={<AddUpdateSubtask />} />
            <Route
              path="add/project/subtask/:projectId/:taskId"
              element={<AddUpdateSubtask />}
            />
            <Route path="add/task/:projectId" element={<AddUpdateTask />} />
            <Route
              path="update/task/:projectId/:taskId"
              element={<AddUpdateTask />}
            />
            <Route
              path="add/subtask/:projectId/:taskId"
              element={<AddUpdateSubtask />}
            />
            <Route
              path="update/task/subtask/:subtaskId"
              element={<AddUpdateSubtask />}
            />
            <Route
              path="update/project/:projectId/task/subtask/:subtaskId"
              element={<AddUpdateSubtask />}
            />
            <Route path="project" element={<Project />} />
            <Route path="add/project" element={<AddUpdateProject />} />
            <Route
              path="update/project/:projectId"
              element={<AddUpdateProject />}
            />
            <Route
              path="notification"
              element={<Notification isStaffNotification={true} isNotificationList={true} />}
            />
            <Route
              path="add/notification"
              element={<Notification isStaffNotification={true} isNotificationList={false} />}
            />
            <Route
              path="view/notification"
              element={<AddNotification />}
            />
            <Route
              path="report"
              element={<Report />}
            />
            <Route
              path="user-activity"
              element={<UserActivity />}
            />
            <Route path="*" element={<Navigate to="/sign-in" />} />
            {/* <Route path="signup" element={<SellerSignup />} /> */}
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
